module.exports = __webpack_public_path__ + "static/media/lack-of-bleeding-ON.fce0eeca.png";